var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlucoseIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #105742;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.4,22.5c0,3-2.4,5.5-5.3,5.5-3,0-5.5-2.4-5.5-5.3,0,0,0,0,0-.1,0-3,5.4-11.3,5.4-11.3,0,0,5.4,8.3,5.4,11.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.8,2.7H12.2c-1.6,0-2.9,1.3-2.9,2.9v35c0,1.6,1.3,2.9,2.9,2.9h10.4v3.4h5v-3.4h10.3c1.6,0,2.9-1.3,2.9-2.9V5.6c0-1.6-1.3-2.9-2.9-2.9h0ZM20.9,40h-5.8c-1,0-1.8-.8-1.8-1.8v-2.3c0-1,.8-1.8,1.8-1.8h5.8c1,0,1.8.8,1.8,1.8v2.3c0,1-.8,1.8-1.8,1.8h0ZM36.7,38.3c0,1-.8,1.8-1.8,1.8h-5.8c-1,0-1.8-.8-1.8-1.8v-2.3c0-1,.8-1.8,1.8-1.8h5.8c1,0,1.8.8,1.8,1.8v2.3h0ZM36.7,29c0,1-.8,1.8-1.8,1.8H15.1c-1,0-1.8-.8-1.8-1.8V8.6c0-1,.8-1.8,1.8-1.8h19.8c1,0,1.8.8,1.8,1.8,0,0,0,20.4,0,20.4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlucoseIconWhite);
export default __webpack_public_path__ + "static/media/glucose-icon-white.d7a62ae7.svg";
export { ForwardRef as ReactComponent };